import { BodyType as e } from "./components.js";
const t = {
  name: "physics-part",
  components: ["body", "collider", "transform", "renderer"]
}, i = {
  ...t,
  name: "static-part",
  overrides: {
    "body.type": e.Fixed,
    "body.mass": 0,
    "body.gravity-scale": 0
  }
}, r = {
  ...t,
  name: "dynamic-part",
  overrides: {
    "body.type": e.Dynamic
  }
}, c = {
  ...t,
  name: "kinematic-part",
  overrides: {
    "body.type": e.KinematicVelocityBased,
    "body.gravity-scale": 0
  }
};
export {
  r as dynamicPartRecipe,
  c as kinematicPartRecipe,
  i as staticPartRecipe
};
//# sourceMappingURL=recipes.js.map
